<div class="card" *ngIf="queue" aria-live="polite">
  <!-- Header -->
  <div class="head">
    <h3 class="title">{{ queue?.name || '—' }}</h3>

    <div class="head-cta">
      <!-- nouveau wrapper pour aligner le libellé Ouvert/Fermé et le bouton Détails -->
      <div class="toggle-group" [class.pending]="isToggling" [attr.aria-busy]="isToggling">
        <label class="toggle">
          <input
            type="checkbox"
            [checked]="isOpen()"
            [disabled]="isToggling"
            (change)="toggleOpen($event.target.checked)" />
          <span class="track"><span class="thumb"></span></span>
          <span class="state" [class.open]="isOpen()" [class.closed]="!isOpen()">
            <span class="dot" [class.on]="isOpen()" [class.off]="!isOpen()"></span>
            {{ (isOpen() ? 'components.queueCard.status.open' : 'components.queueCard.status.closed') | translate }}
          </span>
        </label>
      </div>
    </div>
  </div>

  <!-- Ligne Attente communiquée -->
  <div class="badge-line" *ngIf="now as n">
    <img class="badge-img"
         [src]="statusBadgeSrc(n)"
         [alt]="statusBadgeAlt(n)"
         [attr.aria-label]="isOpen() ? (('components.queueCard.levelAriaLabel' | translate:{ level: levelLabel(n) })) : ('components.queueCard.status.closed' | translate)"/>

    <span class="muted">•</span>

    <!-- Chip compact Mode + Confiance -->
    <button
      type="button"
      class="mode-chip --tight"
      [class.mode-auto]="n.source !== 'MANUAL' && n.source !== 'SENSOR'"
      [class.mode-sensor]="n.source === 'SENSOR'"
      (click)="openModeDetails()"
      [disabled]="!now"
      [attr.aria-label]="modeAria(n)"
      [attr.data-tip]="(n.source === 'MANUAL' ? 'components.queueCard.modeTip.manual' : n.source === 'SENSOR' ? 'components.queueCard.modeTip.sensor' : 'components.queueCard.modeTip.auto') | translate">

      <span class="mode-chip__label">{{ (n.source === 'MANUAL' ? 'components.queueCard.mode.manual' : n.source === 'SENSOR' ? 'components.queueCard.mode.sensor' : 'components.queueCard.mode.auto') | translate }}</span>

      <span class="mode-chip__sep" aria-hidden="true"></span>

      <span class="mode-chip__info" role="img" [attr.aria-label]="'components.queueCard.moreInfoAriaLabel' | translate">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.2"/>
          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5" opacity="0.3"/>
          <text x="12" y="17" font-size="14" font-weight="bold" text-anchor="middle" fill="currentColor">?</text>
        </svg>
      </span>
    </button>
  </div>

  <!-- Corps -->
  <div class="content" *ngIf="now as n">
    <div class="left">
      <div class="kv">
        <div class="label">{{ 'components.queueCard.totalQrScans' | translate }}</div>
        <div class="value value-inline">
          <ng-container *ngIf="totalQrScans !== null && totalQrScans !== undefined; else noQr">
            <span class="value-num">{{ totalQrScans }}</span>
          </ng-container>
          <ng-template #noQr>---</ng-template>
        </div>
      </div>

      <div class="kv">
        <div class="label">{{ 'components.queueCard.patientSatisfaction' | translate }}</div>
        <div class="value value-inline">
          <ng-container *ngIf="patientSatisfaction !== null && patientSatisfaction !== undefined; else noSat">
            <span class="value-num">{{ patientSatisfaction }}</span>
          </ng-container>
          <ng-template #noSat>---</ng-template>
        </div>
      </div>

      <div class="kv">
        <div class="label">{{ 'components.queueCard.lastUpdate' | translate }}</div>
        <div class="value">
          <ng-container *ngIf="n.last_update; else dash">
            {{ formatLastUpdate(n.last_update) }}
          </ng-container>
          <ng-template #dash>---</ng-template>
        </div>
      </div>
    </div>

    <!-- Anneau -->
    <div
      class="ring"
      [class.open]="isOpen()"
      [class.closed]="!isOpen()"
      [class.flash]="savedFlash"
      [class.state-ack-open]="stateAck && stateAckKind==='open'"
      [class.state-ack-closed]="stateAck && stateAckKind==='closed'"
      (wheel)="onCardWheel($event)">

      <svg class="ring-svg" viewBox="0 0 160 160" preserveAspectRatio="xMidYMid meet" role="img" [attr.aria-label]="'components.queueCard.waitAriaLabel' | translate">
        <defs>
          <linearGradient [attr.id]="'rg-'+(queue?.id || 'x')" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%"  [attr.stop-color]="ringStart(level(n))"></stop>
            <stop offset="100%" [attr.stop-color]="ringColor(level(n))"></stop>
          </linearGradient>
        </defs>

        <circle cx="80" cy="80" r="66" class="ring-outer" [attr.stroke]="ringOuter(level(n))" stroke-width="3" fill="none"></circle>
        <circle class="ring-track" cx="80" cy="80" r="60" [attr.stroke]="trackColor(level(n))" stroke-width="12" fill="none"></circle>

        <circle class="ring-progress" cx="80" cy="80" r="60" stroke-width="12" [attr.stroke]="'url(#rg-'+(queue?.id || 'x')+')'"
                fill="none" pathLength="100" [attr.stroke-dasharray]="100" [attr.stroke-dashoffset]="dashOffsetNorm(n)"></circle>

        <circle cx="80" cy="80" r="49" class="ring-inner" [attr.stroke]="ringInner(level(n))" stroke-width="3" fill="none"></circle>
        <circle cx="80" cy="80" r="47" fill="#FFFFFF"></circle>

        <g class="success" [class.on]="savedFlash" pointer-events="none">
          <circle class="sweep" cx="80" cy="80" r="60" fill="none" stroke="#22C55E" stroke-width="12" stroke-linecap="round"></circle>
          <path class="check" d="M58 82 l12 12 26-26" fill="none" stroke="#22C55E" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"></path>
        </g>
      </svg>

      <div class="ring-center" [class.bump]="ringBump">
        <div class="center open-content">
          <div class="minutes" [style.color]="minutesColor(level(n))">{{ minutesToShow(n) }}</div>
          <div class="unit">{{ 'components.queueCard.minutesUnit' | translate }}</div>
        </div>
        <svg class="center-cross" viewBox="0 0 24 24" [attr.aria-label]="'components.queueCard.status.closed' | translate" focusable="false" aria-hidden="true">
          <path d="M7 7l10 10M17 7L7 17" stroke="#EF4444" stroke-width="3.5" stroke-linecap="round"/>
        </svg>
      </div>
    </div>
  </div>

  <!-- Contrôles -->
  <div class="control" *ngIf="now as n">
    <div class="ctrl-label">{{ 'components.queueCard.manualEditLabel' | translate }}</div>

    <div class="row" [class.disabled]="!isOpen()">
      <input class="num" type="number" [min]="0" [max]="maxSlider(n)" step="1" [(ngModel)]="draftMinutes" [disabled]="!isOpen()" [attr.aria-disabled]="!isOpen()" />
      <input class="slider" type="range" [min]="0" [max]="maxSlider(n)" step="1" [attr.list]="'ticks-' + (queue?.id || '')" [(ngModel)]="draftMinutes" [disabled]="!isOpen()" [attr.aria-disabled]="!isOpen()" />
    </div>

    <div class="cause-row" [class.disabled]="!isOpen()">
      <select class="cause-select" [(ngModel)]="selectedCause" [disabled]="!isOpen()" [class.placeholder]="selectedCause === ''">
        <option value="">{{ 'components.queueCard.causeSelectPlaceholder' | translate }}</option>
        <option value="Affluence exceptionnelle">{{ 'components.queueCard.causes.overcrowding' | translate }}</option>
        <option value="Manque de personnel">{{ 'components.queueCard.causes.staffShortage' | translate }}</option>
        <option value="Problème technique">{{ 'components.queueCard.causes.technicalIssue' | translate }}</option>
        <option value="Urgence médicale">{{ 'components.queueCard.causes.medicalEmergency' | translate }}</option>
        <option value="Retard équipe">{{ 'components.queueCard.causes.teamDelay' | translate }}</option>
        <option value="Panne équipement">{{ 'components.queueCard.causes.equipmentFailure' | translate }}</option>
        <option value="Autre">{{ 'components.queueCard.causes.other' | translate }}</option>
      </select>
    </div>

    <datalist [attr.id]="'ticks-' + (queue?.id || '')">
      <option *ngFor="let _ of [].constructor(11); let i = index" [value]="i * (maxSlider(n)/10)"></option>
    </datalist>

    <div class="actions">
      <button class="primary" [class.saving]="isSaving" [disabled]="isSaving || !hasPendingChange" (click)="saveChanges()">
        <svg *ngIf="isSaving" class="spin" viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="9" stroke="white" stroke-width="3" fill="none" opacity=".25"></circle>
          <path d="M21 12a9 9 0 0 0-9-9" stroke="white" stroke-width="3" fill="none" stroke-linecap="round"></path>
        </svg>
        {{ isSaving
            ? ('components.queueCard.actions.saving' | translate)
            : (pendingWaitChange
                ? ('components.queueCard.actions.validateWithMinutes' | translate:{ minutes: draftMinutes })
                : ('components.queueCard.actions.validate' | translate)) }}
      </button>
      <button class="cancel" *ngIf="hasPendingChange && !isSaving" (click)="cancelChanges()">
        {{ 'components.queueCard.actions.cancel' | translate }}
      </button>
    </div>
  </div>

  <!-- Toast succès -->
  <div class="ora-toast" *ngIf="toastVisible" role="status" aria-live="assertive">
    <span class="ora-ico-badge" aria-hidden="true">
      <img class="ora-ico" src="assets/IconORA.svg" alt="">
    </span>
    <span class="ora-txt">
      <span class="ora-title">{{ 'components.queueCard.oraToast.title' | translate }}</span>
      <span class="ora-sub">{{ toastSubtitle }}</span>
    </span>
  </div>

  <!-- Nouvelle modale mode détails -->
  <app-mode-details-modal
    [show]="showModeDetails"
    [title]="(now?.source === 'MANUAL' ? 'components.queueCard.modalTitle.manual' : now?.source === 'SENSOR' ? 'components.queueCard.modalTitle.sensor' : 'components.queueCard.modalTitle.auto') | translate"
    [nowData]="now || null"
    [isOpen]="isOpen()"
    (close)="closeModeDetails()">
  </app-mode-details-modal>
</div>
